import { cardItems } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            热门黑料专题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            精选全网最热门的51黑料吃瓜入口最新内容，每日更新，不容错过
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardItems.map((item, idx) => (
            <article
              key={idx}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.currentTarget as HTMLImageElement).style.display = 'none';
                  }}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-1 bg-accent-500 text-background-50 text-xs font-medium rounded whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute top-3 right-3 flex items-center gap-1 text-white/90 text-xs">
                  <i className="ri-eye-line"></i>
                  <span>{item.hot}</span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}